/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespIconBubbles_item$ref = any;
type PdpRespTradeIconBubbles_item$ref = any;
export type PdpRespIconBubblesWrapper_item$ref = any;
export type PdpRespIconBubblesWrapper_item = {
    readonly " $fragmentRefs": PdpRespIconBubbles_item$ref & PdpRespTradeIconBubbles_item$ref;
    readonly " $refType": PdpRespIconBubblesWrapper_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespIconBubblesWrapper_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespIconBubbles_item",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "PdpRespTradeIconBubbles_item",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'f772fc672a6929d8b888ed1950bbfa1e';
export default node;
